import {DodgerBlueColor} from '../../cmsMainStyle'

const userGroupListStyle = theme => ({
	groupListArea: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 250),
		overflowY: "auto",
		overflowX: "hidden",
	},

	groupListBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		marginLeft: theme.spacing(1),
	},

	addGroupBtnArea: {
		textAlign: "center",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	addGroupBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},

	divider: {
		marginLeft: theme.spacing(8)
	},

	resultMsg: {
		paddingLeft: theme.spacing(2),
		paddingBottom: theme.spacing(2),
	},

})

export {userGroupListStyle}